import { Pipe, PipeTransform } from '@angular/core';
import { cloneDeep } from 'lodash';

@Pipe({
  name: 'im-date',
})
export class IDatePipe implements PipeTransform {
  transform(value: Date | string | number, format: string): string {
    const date = new Date(value);
    const day = date.getDate().toString();
    const month = (date.getMonth() + 1).toString();
    const year = date.getFullYear().toString();
    const hours = date.getHours().toString();
    const minutes = date.getMinutes().toString();
    const seconds = date.getSeconds().toString();

    format = format.replace('jj', +day < 10 ? `0${day}` : day);
    format = format.replace('MM', +month < 10 ? `0${month}` : month);
    format = format.includes('aaaa')
      ? format.replace('aaaa', year)
      : format.includes('aa')
        ? format.replace(
            'aa',
            `${year[year.length - 2]}${year[year.length - 1]}`,
          )
        : format;
    format = format.replace('HH', +hours < 10 ? `0${hours}` : hours);
    format = format.replace('mm', +minutes < 10 ? `0${minutes}` : minutes);
    format = format.replace('ss', +seconds < 10 ? `0${seconds}` : seconds);

    const result = cloneDeep(format);

    return result;
  }
}
